import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { InvoiceRule } from './rule.model'

export interface State extends EntityState<InvoiceRule> {
  isLoaded: boolean
  isAdding: boolean
  isUpdating: boolean
}

export const adapter: EntityAdapter<InvoiceRule> = createEntityAdapter<InvoiceRule>({
  sortComparer: false,
  selectId: (i: InvoiceRule) => i.pkey,
})

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
  isAdding: false,
  isUpdating: false,
})
